import './modal.sass';

export default {
	props: {
		type: {
			required: false,
			type: String,
			default: ''
		},
		closeDisabled: {
			required: false,
			default: false,
			type: Boolean
		},
		showBottomClose: {
			required: false,
			default: false,
			type: Boolean
		},
		link: {
			required: false,
			default: '',
			type: String
		}
	},

	template: `
		<transition name="modal-fade">
			<div class="modal-backdrop" @click.stop.self="close($event)">
				<div class="modal" @click.self.stop.prevent>
					<section class="modal-body" :class="type">
						<template v-if="!closeDisabled">
							<button
								v-if="link.length === 0"
								class="btn-close"
								@click.stop="close($event)"
							>
								<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.64645 1.64645c.19526-.19527.51184-.19527.7071 0L10.5 9.79289l8.1464-8.14644c.1953-.19527.5119-.19527.7071 0 .1953.19526.1953.51184 0 .7071L11.2071 10.5l8.1464 8.1464c.1953.1953.1953.5119 0 .7071-.1952.1953-.5118.1953-.7071 0L10.5 11.2071l-8.14644 8.1464c-.19526.1953-.51184.1953-.70711 0-.19526-.1952-.19526-.5118 0-.7071L9.79289 10.5 1.64645 2.35355c-.19527-.19526-.19527-.51184 0-.7071z" fill="currentColor"/></svg>
							</button>
							<a v-else :href="link" class="btn-close">
								<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.64645 1.64645c.19526-.19527.51184-.19527.7071 0L10.5 9.79289l8.1464-8.14644c.1953-.19527.5119-.19527.7071 0 .1953.19526.1953.51184 0 .7071L11.2071 10.5l8.1464 8.1464c.1953.1953.1953.5119 0 .7071-.1952.1953-.5118.1953-.7071 0L10.5 11.2071l-8.14644 8.1464c-.19526.1953-.51184.1953-.70711 0-.19526-.1952-.19526-.5118 0-.7071L9.79289 10.5 1.64645 2.35355c-.19527-.19526-.19527-.51184 0-.7071z" fill="currentColor"/></svg>
							</a>
						</template>
						<slot name="body"></slot>
						<template v-if="showBottomClose">
							<component
								:is="link ? 'a' : 'button'"
								:href="link" @click.stop="close($event)"
								class="modal__btn-close modal__btn-close--mobile"
							>
								Закрыть
							</component>
						</template>
					</section>
				</div>
			</div>
		</transition>
	`,

	methods: {
		close(event) {
			this.$emit('close', event);
			// eslint-disable-next-line
			BX.Vue.event.$emit('root-modal-closed');
		},
		checkValidation() {
			return this.$children.some(item => item.hasError);
		}
	},

	created() {
		document.querySelector('body').classList.add('hidden');
	},

	destroyed() {
		document.querySelector('body').classList.remove('hidden');
	}
};
